var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 280,
    viewBox: "10 10 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #NaNNaNNaN;\n        stroke-width: 0;\n        stroke-dasharray: 0.001 0 0 0;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    className: "cls-1",
    d: "M50.343,53.038l5.006-4.893a5,5,0,0,1,7.071.081L249.738,239.892a5,5,0,0,1-.081,7.07l-5.006,4.893a5,5,0,0,1-7.07-.081L50.262,60.109A5,5,0,0,1,50.343,53.038Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1_copiar",
    "data-name": "Ret\\xE2ngulo 1 copiar",
    className: "cls-1",
    d: "M50.343,246.962l5.006,4.893a5,5,0,0,0,7.071-.081L249.738,60.109a5,5,0,0,0-.081-7.071l-5.006-4.893a5,5,0,0,0-7.07.081L50.262,239.892A5,5,0,0,0,50.343,246.962Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.99b4d3eb3f214cf0e66cfd725811308d.svg";
export { ForwardRef as ReactComponent };